import ApplicationVerification from "./ApplicationVerification";
import GohonzonAllotment from "./GohonzonAllotment";
import GohonzonApplications from "./GohonzonApplications";
import GohonzonApply from "./GohonzonApply";
import GohonzonBatchConferral from "./GohonzonBatchConferral";
import GohonzonCancellation from "./GohonzonCancellation";
import GohonzonConferral from "./GohonzonConferral";
import GohonzonHandover from "./GohonzonHandover";
import GohonzonInterview from "./GohonzonInterview";
import GohonzonVerification from "./GohonzonVerification";
import GohonzonApproval from "./GohonzonApproval";
import GohonzonBatchAllotment from "./GohozonBatchAllotment";
import ReturnedGohonzonHandover from "./ReturnedGohonzonHandover";
import GohonzonReturnRequest from "./GohonzonReturnRequest";
import GohonzonReturnVerification from "./GohonzonReturnVerification";
import GohonzonOmamoriConferral from "./GohonzonOmamoriConferral";
import GohonzonReplacementConferral from "./GohonzonReplacementConferral";
import {
  GOHONZON_ALLOTMENT_COL,
  GOHONZON_APPLICATIONS_COL,
  GOHONZON_APPLICATION_VERIFICATION_COL,
  GOHONZON_APPLY_TABLE_COL,
  GOHONZON_BATCH_CONFERRAL_COL,
  GOHONZON_CANCEL_REQ_COL,
  GOHONZON_CONFERRAL_COL,
  GOHONZON_INTERVIEW_COL,
  GOHONZON_VERIFICATION_COL,
  GOHOZON_BATCH_ALLOTMENT_COL,
  GOHOZON_HANDOVER_COL,
  RETURNED_GOHONZON_HANDOVER_COL,
  GOHONZON_RETURN_REQ_COL,
  GOHONZON_RETURN_VERIFICATION_COL,
  GOHONZON_OMAMORI_ALLOTMENT_COL,
  GOHONZON_OMAMORI_HANDOVER_COL,
  GOHONZON_APPROVAL_COL,
  GOHONZON_OMAMORI_CONFERRAL_COL,
  GOHONZON_REPLACEMENT_CONFERRAL_COL,
  GOHOZON_BATCH_HISTORY_COL,
  GOHONZON_BATCH_VIEW_COL,
} from "../../contants/table/gohonzonSearch";
import { GOHONZON_TABLES_MAP } from "../../contants/gohonzon";
import GohonzonOmamoriAllotment from "./GohonzonOmamoriAllotment";
import GohonzonOmamoriHandover from "./GohonzonOmamoriHandover";
import GohonzonReplacementVerification from "./GohonzonReplacementVerification";
import GohonzonBatchHistory from "./GohonzonBatchHistory";
import GohonzonAllotmentHistory from "./GohonzonAllotmentHistory";
import GohonzonView from "./ViewGohonzonBatch";

export const getTableContent = (type) => {
  if (type === GOHONZON_TABLES_MAP.GOHONZON_APPLICATIONS) {
    return {
      colums: GOHONZON_APPLICATIONS_COL,
      subHeading: "Submitted Gohonzon Applications",
      component: GohonzonApplications,
    };
  }
  if (type === GOHONZON_TABLES_MAP.APPLICATION_VERIFICATION) {
    return {
      colums: GOHONZON_APPLICATION_VERIFICATION_COL,
      subHeading: "Submitted Gohonzon Applications",
      component: ApplicationVerification,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_RETURN_VERIFICATION) {
    return {
      colums: GOHONZON_RETURN_VERIFICATION_COL,
      subHeading: "Submitted Gohonzon Replacement Applications",
      component: GohonzonReturnVerification,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_REPLACEMENT_VERIFICATION) {
    return {
      colums: GOHONZON_RETURN_VERIFICATION_COL,
      subHeading: "Submitted Gohonzon Replacement Applications",
      component: GohonzonReplacementVerification,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_INTERVIEW) {
    return {
      colums: GOHONZON_INTERVIEW_COL,
      subHeading: "Pending Application",
      component: GohonzonInterview,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_VERIFICATION) {
    return {
      colums: GOHONZON_VERIFICATION_COL,
      subHeading: "Batch Processing",
      component: GohonzonVerification,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_BATCH_ALLOTMENT) {
    return {
      colums: GOHOZON_BATCH_ALLOTMENT_COL,
      subHeading: "Gohonzon Batches",
      component: GohonzonBatchAllotment,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_BATCH_HISTORY) {
    return {
      colums: GOHOZON_BATCH_HISTORY_COL,
      subHeading: "Gohonzon Batch History",
      component: GohonzonBatchHistory,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_ALLOTMENT) {
    return {
      colums: GOHONZON_ALLOTMENT_COL,
      subHeading: "Submitted Gohonzon Applications",
      component: GohonzonAllotment,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_BATCH_VIEW) {
    return {
      colums: GOHONZON_BATCH_VIEW_COL,
      subHeading: "Gohonzon Applications",
      component: GohonzonView,
    };
  }
  if (type === GOHONZON_TABLES_MAP.ALLOTMENT_HISTORY) {
    return {
      colums: GOHONZON_ALLOTMENT_COL,
      subHeading: "Gohonzon Allotment History",
      component: GohonzonAllotmentHistory,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_HANDOVER) {
    return {
      colums: GOHOZON_HANDOVER_COL,
      subHeading: "Gohonzon Batch Handover",
      component: GohonzonHandover,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_BATCH_CONFERRAL) {
    return {
      colums: GOHONZON_BATCH_CONFERRAL_COL,
      subHeading: "Conferral",
      component: GohonzonBatchConferral,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_CONFERRAL) {
    return {
      colums: GOHONZON_CONFERRAL_COL,
      subHeading: "Member Conferral",
      component: GohonzonConferral,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_CANCEL_REQUEST) {
    return {
      colums: GOHONZON_CANCEL_REQ_COL,
      subHeading: "Request Gohonzon Cancelation",
      component: GohonzonCancellation,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_RETURNED_HANDOVER) {
    return {
      colums: RETURNED_GOHONZON_HANDOVER_COL,
      subHeading: "Gohonzon Handover",
      component: ReturnedGohonzonHandover,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_RETURN_REQUEST) {
    return {
      colums: GOHONZON_RETURN_REQ_COL,
      subHeading: "Request Gohonzon Return",
      component: GohonzonReturnRequest,
    };
  }

  // Omamori Allotment&Handover Table for Admin
  if (type === GOHONZON_TABLES_MAP.GOHONZON_OMAMORI_ALLOTMENT) {
    return {
      colums: GOHONZON_OMAMORI_ALLOTMENT_COL,
      subHeading: "Submitted Gohonzon Application",
      component: GohonzonOmamoriAllotment,
    };
  }

  if (type === GOHONZON_TABLES_MAP.GOHONZON_OMAMORI_HANDOVER) {
    return {
      colums: GOHONZON_OMAMORI_HANDOVER_COL,
      subHeading: "Gohonzon Handover",
      component: GohonzonOmamoriHandover,
    };
  }

  if (type === GOHONZON_TABLES_MAP.GOHONZON_APPROVAL) {
    return {
      colums: GOHONZON_APPROVAL_COL,
      subHeading: "Submitted Omamori Gohonzon Applications",
      component: GohonzonApproval,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_OMAMORI_CONFERRAL) {
    return {
      colums: GOHONZON_OMAMORI_CONFERRAL_COL,
      subHeading: "Member Conferral",
      component: GohonzonOmamoriConferral,
    };
  }
  if (type === GOHONZON_TABLES_MAP.GOHONZON_REPLACEMENT_CONFERRAL) {
    return {
      colums: GOHONZON_REPLACEMENT_CONFERRAL_COL,
      subHeading: "Member Conferral",
      component: GohonzonReplacementConferral,
    };
  }
  return {
    colums: GOHONZON_APPLY_TABLE_COL,
    subHeading: "",
    component: GohonzonApply,
  };
};
